import axios from "axios";

const baseURL = 'http://18.134.133.59:4000/api/v1.0';

export const fetchDataSummary = async () =>{
    const { data } = await axios.get(`${baseURL}/evaluator-list`);
    const dataSummary= {
        statusCount: data.StatusCount,
        zoneCount: data.zoneCount,
        stateCount: data.stateCount
    }

    return dataSummary;
}